// extracted by mini-css-extract-plugin
export default {"mainFieldContainer":"QasRequirementsPage_mainFieldContainer__sUJdn","adminIconArea":"QasRequirementsPage_adminIconArea__qfI6Z"};